import type { Resident, Image } from '@zs/shared/schema';

const IMAGE_BASE_URL = import.meta.env.VITE_IMAGE_URL || '';

interface Props {
  resident: Resident;
}

function getImageUrl(image: Image): string {
  return `${IMAGE_BASE_URL}/images/${image.storageKey}`;
}

export function ResidentCard({ resident }: Props) {
  const images = resident.images || [];
  const hasImages = images.length > 0;
  const mainImage = hasImages ? getImageUrl(images[0]) : null;
  const thumbnails = images.slice(1);

  return (
    <div className="resident-card">
      {mainImage ? (
        <img src={mainImage} alt={resident.name} loading="lazy" />
      ) : (
        <div className="resident-card-placeholder">📷</div>
      )}
      {thumbnails.length > 0 && (
        <div className="resident-card-thumbnails">
          {thumbnails.map((thumb) => (
            <img
              key={thumb._id}
              src={getImageUrl(thumb)}
              alt=""
              loading="lazy"
            />
          ))}
        </div>
      )}
      <h3>{resident.name}</h3>
      <p className={`status status-${resident.status}`}>{resident.status}</p>
    </div>
  );
}
